import React from "react";

/** Chips to switch between / remove shipments when several AWBs are tracked. */
const TrackedShipments = ({ ids, activeId, onView, onRemove, onClearAll }) => {
  if (ids.length < 2) return null;

  return (
    <div className="tracked-list" aria-label="Tracked shipments">
      {ids.map((id) => (
        <span key={id} className={`tracked-chip ${id === activeId ? "active" : ""}`}>
          <button type="button" className="tracked-chip-label" onClick={() => onView(id)}>
            {id}
          </button>
          <button
            type="button"
            className="tracked-chip-remove"
            aria-label={`Remove ${id}`}
            onClick={() => onRemove(id)}
          >
            ×
          </button>
        </span>
      ))}
      <button type="button" className="link-btn" onClick={onClearAll}>
        Clear all
      </button>
    </div>
  );
};

export default TrackedShipments;
